const MESSAGE_MODEL = {
  id: { id: 'id' },
  body: { id: 'body', label: 'Message', truncate: 40 },
  senderId: { id: 'senderId' },
  senderName: { id: 'senderFullName' },
  title: { id: 'title', label: 'title' },
  acknowledgedAt: { id: 'acknowledgedAt', label: 'Acknowledged At' },
  createdAt: { id: 'createdAt', label: 'Created At' },
  notificationType: { id: 'notificationType' },
  objectId: { id: 'objectId' },
  priority: { id: 'priority', label: 'Priority' },
  recipientId: { id: 'recipientId' },
  recipientName: { id: 'recipientFullName', label: 'Recipient Name' },
  sentAt: { id: 'sentAt', label: 'Sent At' },
  service: { id: 'service' },
};

export default MESSAGE_MODEL;
